import { Icon, IconProps } from './Icon';

interface FastPacedIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const FastPacedIcon = ({ color = '#C2E2FF', gradient, ...props }: FastPacedIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 46 45"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5057 23.7842L25.3056 3.09378C26.0419 2.12966 27.578 2.78679 27.3892 3.98509L25.054 18.8048C25.026 18.9821 25.1631 19.1424 25.3426 19.1424H35.2855C36.2534 19.1424 36.8019 20.2514 36.2145 21.0207L20.4146 41.7111C19.6783 42.6752 18.1422 42.018 18.331 40.8197L20.6662 26.0001C20.6942 25.8227 20.5571 25.6624 20.3776 25.6624H10.4346C9.4668 25.6624 8.9183 24.5534 9.5057 23.7842Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
